<div *ngIf="isLoaded">
  <div class="rejection-details" *ngIf="taskStatus && ['Rejected'].includes(taskStatus)">
    <app-rejection-details [supplierCode]='supplierCode' [rejectionDetails]='rejectionDetails'></app-rejection-details>
  </div>
  <div *ngIf="taskStatus && ['New', 'Rejected'].includes(taskStatus); else OtherContact">
    <h4 *ngIf="supplierAddressType === 'Manufacturing'; else info" style="color: #3E6AE1"
      i18n="@@addressTaskDescription" t="addressTaskDescription">Please confirm or provide your organization’s
      manufacturing address. This address
      should be your manufacturing location where goods or services are being produced and provided to Tesla.</h4>
    <ng-template #info>
      <tsl-alert *ngIf="contextVerbiage" icon="info_blue" style="color: #3E6AE1" status="primary">{{
        translate.get(contextVerbiage.address.description) }}
      </tsl-alert>
    </ng-template>
    <ng-container *ngIf="requestType || isReactivation || enableExistSelection">
      <ng-container *ngIf="['nameOrTINChange'].includes(requestType); else singleSelectForm">
        <app-exist-select #selectTable
            [columns]="displayedColumns"
            [masterData]="tableData"
            (onSelect)="onSelected($event)"
            (onView)="onView($event)"
            (onEdit)="onEdit($event)"
            (onDelete)="onDelete($event)"
            (onAdd)="onAdd($event)"
        ></app-exist-select>
        <p class="select-table-error-message" *ngIf="!isValidSelectTable">{{ this.translate.get(tableErrorMessage) }}</p>
        <div class="entity-mapping-container">
          <app-entity-mapping #entityMapping [masterData]="entityMappings" [options]="entityMappingOptions" [itemType]="'Address'"></app-entity-mapping>
        </div>
      </ng-container>
      <ng-template #singleSelectForm>
        <div *ngIf="isReactivation || enableExistSelection">
          <app-exist-select
            #selectTable
            [columns]="displayedColumns"
            [masterData]="tableData"
            (onSelect)="onSelected($event)"
            (onEdit)="onEdit($event)"
          ></app-exist-select>
          <p class="select-table-error-message" *ngIf="!isValidSelectTable" i18n="@@addressTaskSelectTableErrorMessage" t="addressTaskSelectTableErrorMessage">Please confirm at least one active address above or add new information.</p>
        </div>
        <br />
        <p class="new-form-title" *ngIf="(isReactivation || enableExistSelection) && isCreateNew" i18n="@@reactivationCreateNewInformationMessage" t="reactivationCreateNewInformationMessage">Please provide new information for your Supplier Profile setup with Tesla.</p>
        <address-edit [hidden]="(isReactivation || enableExistSelection) && !isCreateNew" #addressEdit [tsl-supplierCode]="supplierCode" [tsl-requiredDocuments]="requiredDocuments"
          [tsl-isReactivation]="isReactivation || enableExistSelection"
          [tsl-initialValue]="supplierAddress" [tsl-readOnly]="isTabStatusSubmitted"
          [tsl-addressTypes]="addressTypes$ | async" [tsl-countries]="countries"
          [tsl-defaultAddressTypeName]="supplierAddressType" [tsl-generalSettings]="settings$ | async"
          [tsl-hideSaveButton]="true" [tsl-hideContactDocumentSection]="hideContactDocumentSection"
          (tsl-onSave)="addressFormSubmit($event.supplierAddress)" (tsl-onSaveError)="setErrorMessage($event.errorMessage)">
        </address-edit>
      </ng-template>
    </ng-container>
    
    <button *ngIf="!isSidePanelMode" class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit()"
      i18n="@@Submit" t="Submit">Submit</button>
  </div>
  <ng-template #OtherContact>
    <h3>
      <span i18n="@@taskCompleteRedirect" t="taskCompleteRedirect">Task is already completed please go back to home
        page.</span>
      <a i18n="@@clickHere" t="clickHere" href="javascript:void(0)" (click)="navigateToHome()">Click Here</a>
    </h3>
  </ng-template>
</div>
